import { HTML_LINK_TARGET } from '../../../../constants/html'
import {
  useIsTeamVisibilityHidden,
  useIsUserProfileNGAvailable,
  useUserData,
} from '../../../../hooks'
import { getInhabitantProfilePathname } from '../../../../utils/link'
import { isTeamUserProfileHidden } from '../../../../utils/user'
import { Link } from '../../../Link'
import Text from '../../../Text'
import { getUserLabel } from '../../../User'

function ChatroomSystemMessageUserLink({ className, user }) {
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  const currentUser = useUserData()
  const isTeamHidden = useIsTeamVisibilityHidden()

  const isProfileHidden = isTeamUserProfileHidden({
    currentUser,
    isTeamHidden,
    user,
  })

  const label = user ? getUserLabel(user) : null

  return user?.id && !isProfileHidden ? (
    <Text
      Element={Link}
      className={className}
      target={HTML_LINK_TARGET.blank}
      to={getInhabitantProfilePathname({
        id: user.id,
        isUserProfileNGAvailable,
      })}
    >
      {label}
    </Text>
  ) : user ? (
    <Text>{label}</Text>
  ) : null
}

export default ChatroomSystemMessageUserLink
